module.exports = __webpack_public_path__ + "static/media/Logo.69bf0e45.png";